import { EvalPaneTemplate, EvaluateExpressionType, PaneType } from "./Types.js";

export const EvalPaneTemplates: Record<string, EvalPaneTemplate> = {
  gJQYR54Y1ZpJn5TtlkR7W: {
    id: "gJQYR54Y1ZpJn5TtlkR7W",
    schema: {
      type: "object",
      title: "http request",
      description: "make a HTTP GET request",
      required: ["url"],
      properties: {
        url: { type: "string" },
        responseBody: {
          title: "response body",
          type: "string",
          enum: ["json", "text"],
          default: "json",
        },
      },
    },
    uiSchema: {
      responseBody: {
        "ui:widget": "radio",
        "ui:inline": true,
      },
    },
    construct: (metadata) => {
      return {
        panes: [
          {
            type: PaneType.Evaluate,
            inputs: [],
            expressionType: EvaluateExpressionType.Expression,
            expression:
              metadata.url?.length > 0
                ? `fetch("${metadata.url}")\n  .then(r => r.${metadata.responseBody}())`
                : `// missing url`,
          },
        ],
        inputs: [],
      };
    },
  },
  wUJZAlhtesCDmGazBqdah: {
    id: "wUJZAlhtesCDmGazBqdah",
    schema: {
      type: "object",
      title: "view image url",
      description: "render an image tag",
      properties: {
        width: { type: "string" },
        height: { type: "string" },
      },
    },
    construct: (metadata) => {
      return {
        panes: [
          {
            type: PaneType.Evaluate,
            inputs: [{ name: "src", source: "src" }],
            expressionType: EvaluateExpressionType.Expression,
            expression: `\`<img src="\${src}"${
              metadata.width !== undefined ? ` width="${metadata.width}"` : ""
            }${
              metadata.height !== undefined
                ? ` height="${metadata.height}"`
                : ""
            } />\``,
            renderOutput: ["html"],
          },
        ],
        inputs: [{ id: "src", name: "src" }],
      };
    },
  },
  dwfGSsdnSSDY0lUUj3LtH: {
    id: "dwfGSsdnSSDY0lUUj3LtH",
    schema: {
      type: "object",
      title: "plot line graph",
      description: "use @observablehq/plot to render a line graph",
      properties: {
        x: {
          type: "object",
          oneOf: [
            {
              title: "column name",
              properties: { key: { type: "string" } },
            },
            {
              title: "column function",
              properties: {
                code: { type: "string", description: "datum => value" },
              },
            },
          ],
        },
        y: {
          type: "object",
          oneOf: [
            {
              title: "column name",
              properties: { key: { type: "string" } },
            },
            {
              title: "column function",
              properties: {
                code: { type: "string", description: "datum => value" },
              },
            },
          ],
        },
      },
    },
    construct: (metadata) => {
      const x =
        metadata.x !== undefined
          ? metadata.x.key !== undefined
            ? `"${metadata.x.key}"`
            : metadata.x.code
          : undefined;
      const y =
        metadata.y !== undefined
          ? metadata.y.key !== undefined
            ? `"${metadata.y.key}"`
            : metadata.y.code
          : undefined;
      return {
        panes: [
          {
            type: PaneType.Evaluate,
            inputs: [
              { name: "Plot", source: [1] },
              { name: "data", source: "data" },
            ],
            expressionType: EvaluateExpressionType.Expression,
            expression: `Plot.plot({
  marks: [${
    x !== undefined && y !== undefined
      ? `\n    Plot.line(data, {
      x: ${x},
      y: ${y},
    }),`
      : x !== undefined
      ? `\n    Plot.lineX(data, {
      x: ${x},
    }),`
      : y !== undefined
      ? `\n    Plot.lineY(data, {
      y: ${y},
    }),`
      : `\n    Plot.line(data),`
  }
  ],
})`,
            renderOutput: ["dom"],
          },
          {
            rect: [-384, 0, 288, 192],
            type: PaneType.Import,
            module: ["npm", "@observablehq/plot"],
            name: "Plot",
          },
        ],
        inputs: [{ id: "data", name: "data" }],
      };
    },
  },
  A9kGmOINYTnm79soQ6PGW: {
    id: "A9kGmOINYTnm79soQ6PGW",
    schema: {
      type: "object",
      title: "array stats",
      description: "calculate common statistics of a number array",
      properties: {},
    },
    construct: (metadata) => {
      return {
        panes: [
          {
            type: PaneType.Evaluate,
            inputs: [{ name: "data", source: "data" }],
            expressionType: EvaluateExpressionType.FunctionBody,
            expression: `const sum = data.reduce((acc, v) => acc + v, 0);
return {
  min: Math.min(...data),
  max: Math.max(...data),
  sum,
  mean: data.length > 0 ? sum / data.length : undefined,
}`,
          },
        ],
        inputs: [{ id: "data", name: "data", description: "array of numbers" }],
      };
    },
  },
  bJBFxqUDNE8To1SpqDXdx: {
    id: "bJBFxqUDNE8To1SpqDXdx",
    schema: {
      type: "object",
      title: "csv parse",
      description: "parse string into array",
      properties: {
        delimiter: {
          type: "string",
        },
        header: {
          type: "boolean",
          description: "if true, first row intepreted as field names",
        },
      },
    },
    uiSchema: {
      delimiter: {
        "ui:placeholder": ",",
      },
    },
    construct: (metadata) => {
      return {
        panes: [
          {
            type: PaneType.Evaluate,
            inputs: [
              { name: "papaparse", source: [1] },
              { name: "input", source: "input" },
            ],
            expressionType: EvaluateExpressionType.Expression,
            expression: `papaparse.parse(input, {
  delimiter: \`${metadata.delimiter ?? ","}\`,${
              metadata.header === true ? `\n  header: true,` : ""
            }
}).data`,
          },
          {
            rect: [-448, 0, 336, 192],
            type: PaneType.Import,
            module: ["npm", "papaparse"],
            name: "papaparse",
            useDefault: true,
          },
        ],
        inputs: [
          { id: "input", name: "input", description: "string to parse" },
        ],
      };
    },
  },
};
